import { render, staticRenderFns } from "./ProductListVerticalCards.vue?vue&type=template&id=4850e982&scoped=true&"
import script from "./ProductListVerticalCards.vue?vue&type=script&lang=js&"
export * from "./ProductListVerticalCards.vue?vue&type=script&lang=js&"
import style0 from "./ProductListVerticalCards.vue?vue&type=style&index=0&id=4850e982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850e982",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
